import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Share2, Copy, Mail, MessageCircle, Check } from "lucide-react";
import { toast } from "sonner";
import { useSettings } from "@/context/AppContext";

const baseUrl = (domain) => (domain ? domain.replace(/\/$/, "") : window.location.origin);

export const ShareBlock = ({ path = "/", compact = false, testid = "share" }) => {
  const { settings } = useSettings() || {};
  const [copied, setCopied] = useState(false);
  const msg = settings?.texts?.share_message || "Conheça a Conexão Litigium, uma plataforma digital para organizar solicitações jurídicas de pessoas físicas e empresas.";
  const url = baseUrl(settings?.brand?.domain) + path;
  const full = `${msg} ${url}`;

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: settings?.brand?.name || "Conexão Litigium", text: msg, url });
      } catch {}
    } else copy();
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Não foi possível copiar");
    }
  };

  return (
    <div className={`flex ${compact ? "flex-col gap-3" : "flex-col gap-6 md:flex-row md:items-center"}`} data-testid={`${testid}-block`}>
      <div className="flex flex-wrap gap-2">
        <button className="btn-primary btn-sm" onClick={nativeShare} data-testid={`${testid}-native-btn`}>
          <Share2 size={16} /> Compartilhar Conexão Litigium
        </button>
        <a className="btn-secondary btn-sm" href={`https://wa.me/?text=${encodeURIComponent(full)}`} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-whatsapp-btn`}>
          <MessageCircle size={16} /> WhatsApp
        </a>
        <button className="btn-secondary btn-sm" onClick={copy} data-testid={`${testid}-copy-btn`}>
          {copied ? <Check size={16} /> : <Copy size={16} />} Copiar link
        </button>
        <a className="btn-secondary btn-sm" href={`mailto:?subject=${encodeURIComponent(settings?.brand?.name || "Conexão Litigium")}&body=${encodeURIComponent(full)}`} data-testid={`${testid}-email-btn`}>
          <Mail size={16} /> E-mail
        </a>
      </div>
      {!compact && (
        <div className="flex items-center gap-3 rounded-2xl border border-[#3198EF]/20 bg-white p-3" data-testid={`${testid}-qrcode`}>
          <QRCodeSVG value={url} size={96} fgColor="#092C66" />
          <span className="max-w-[140px] text-xs text-[#64748B]">Aponte a câmera do celular para abrir</span>
        </div>
      )}
    </div>
  );
};
